import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import RuvixxDate from "components/RuvixxDate";
import CONSTANTS from "constants/Constants";
import { RevalidateMxDomainButton } from "routes/mx_domains/components/RevalidateMxDomainButton";

const { MX_DOMAIN_STATUSES } = CONSTANTS;

const MxDomainStatusBadge = ({ status }) => {
  const statusInfo = MX_DOMAIN_STATUSES.find(({ id }) => id === status);
  if (!statusInfo) return null;
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Badge variant={statusInfo.badgeVariant}>{statusInfo.name}</Badge>
        }
      />
      <TooltipContent>{statusInfo.description}</TooltipContent>
    </Tooltip>
  );
};

const MailServers = ({ records }) => {
  if (!records?.length) {
    return (
      <span className="tw:text-muted-foreground">No mail server found</span>
    );
  }
  return (
    <ul className="tw:m-0 tw:list-none tw:p-0">
      {records.map(record => (
        // DNS returns fully-qualified names with a trailing dot.
        <li key={record}>{record.replace(/\.$/, "")}</li>
      ))}
    </ul>
  );
};

export const getMxDomainsTableColumns = () => [
  {
    header: "Domain",
    id: "Domain",
    accessorKey: "domain",
    size: 220,
    cell: ({ row }) => <p className="tw:font-bold">{row.original?.domain}</p>,
  },
  {
    header: "Status",
    id: "Status",
    accessorKey: "validation_status",
    size: 120,
    cell: ({ row }) => (
      <MxDomainStatusBadge status={row.original?.validation_status} />
    ),
  },
  {
    header: "Last Checked",
    id: "Last Checked",
    accessorKey: "validated_at",
    size: 160,
    cell: ({ row }) => {
      const date = row.original?.validated_at;
      return date ? <RuvixxDate date={date} /> : <span>Never checked</span>;
    },
  },
  {
    header: "Mail Servers",
    id: "Mail Servers",
    accessorKey: "info",
    enableSorting: false,
    size: 260,
    cell: ({ row }) => <MailServers records={row.original?.info?.records} />,
  },
  {
    header: <div></div>,
    id: "Actions",
    accessorKey: "actions",
    enableSorting: false,
    enableResizing: false,
    size: 130,
    meta: { isDisplay: true },
    cell: ({ row }) => <RevalidateMxDomainButton mxDomain={row.original} />,
  },
];

export const getMxDomainsTableFilters = () => [
  {
    key: "validation_status",
    title: "Status",
    type: "select",
    data: MX_DOMAIN_STATUSES.map(({ id, name }) => ({ id, name })),
  },
];
